export default __webpack_public_path__ + "static/media/cashCardPlusFudrPaid.9716b865.svg";